import { render } from "./LeadsListSummary.vue?vue&type=template&id=a2d674e0"
import script from "./LeadsListSummary.vue?vue&type=script&lang=js"
export * from "./LeadsListSummary.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__